import { computed, inject, Injectable, Signal } from '@angular/core';
import { AuthService } from '@libs/shared/auth';

@Injectable({ providedIn: 'root' })
export class PriceVisibilityService {
  public readonly authService: AuthService = inject(AuthService);
  public canSeePrices: Signal<boolean> = computed(() => this.authService.currentCustomer()?.customerUserPermissions.canSeePrices ?? false);
}
